import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import useAuth from "../../../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
import useGetData from "../../../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);

const ViewCheckout = () => {
  const { requisition_id } = useParams();
  const { requisitionCheckout, CountData, requisitionUserNotification } =
    useGetData();
  const { mutate } = CountData();
  const navigate = useNavigate();
  const navigate1 = useNavigate();
  const { mutate: mutate2 } = requisitionUserNotification();
  const logInStatus = parseInt(Cookies.get("Role"));
  const user = JSON.parse(Cookies.get("user") || '{}');
  const { data: viewCheckData } = requisitionCheckout(requisition_id);
  const [productArray, setProductArray] = useState([]);
  const [givenStatus, setGivenStatus] = useState(1);

  useEffect(() => {
    if (viewCheckData) {
      setProductArray(viewCheckData.productsInfo);
    }
  }, [viewCheckData]);

  // console.log(productArray);
  const updateProduct = (id, value, name) => {
    return productArray.map((item) => {
      let myItem = item;

      if (item.PROID === parseInt(id)) {
        if (name === "STOREREMARK") {
          myItem.STOREREMARK = value;
        } else {
          myItem[name] = value;
        }
      }
    });
  };
  // console.log(productArray);
  // console.log(givenStatus);
  const handleRequest = () => {
    console.log(productArray);
    swal({
      title: "Are you sure?",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (productArray.length > 0) {
          const array = productArray.map((product) => {
            console.log("product", product);
            if (product.PROQTY < product.APROQTY) {
              swal({
                title: `${product.PRONAME}`,
                text: ` Doesn't have required quantity to approve !`,
                icon: "error",
                button: "Ok",
              });
            } else {
              const obj = {
                proreqid: product.PROREQID,
                proid: product.PROID,
                qty: product.APROQTY,
                remarks: product.STOREREMARK,
                hridno: product.HRIDNO,
                proname: product.PRONAME,
                procate: product.PROCATE,
              };
              return obj;
            }
          });
          console.log("object", {
            req_id: parseInt(requisition_id),
            approvedBy: user?.name_english,
            products: array,
          });

          API.put("store/requisition/approve/store_officer", {
            req_id: parseInt(requisition_id),
            approvedBy: user?.name_english,
            products: array,
          }).then((res) => {
            console.log("d", res);

            if (!res.data.error) {
              swal({
                title: "Thank you !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              if (parseInt(givenStatus) == 1) {
                API.put(
                  `store/requisition/given/${parseInt(requisition_id)}`,
                  {}
                ).then((res) => {
                  console.log(res);
                });
              }
              PostStoreLog(2, "Store requisition Checkout");
              navigate("/requisitions/approved");
              mutate();
              mutate2();
            } else {
              swal({
                title: "Thank You !",
                text: `${res.data.message}`,
                icon: "danger",
                button: "Ok",
              });
            }
          });
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>View Checkout Requisition - BBA STORE</title>
        <meta
          name="description"
          content="View Pending Requisition - BBA STORE"
        />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate1(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              View Notification of Requisition
            </h3>
          </div>
          {!viewCheckData ? (
            <NotFoundPage />
          ) : (
            <div
              className="my-4 table-container p-2"
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div>
                <div className="row gx-5">
                  <div className="col-12 col-md-7 col-lg-7">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor text-center">
                              <th colSpan="12">Product Requisition Details</th>
                            </tr>
                          </thead>
                          {viewCheckData.reqInfo && (
                            <tbody>
                              <tr>
                                <td colSpan="4">Time & Date</td>
                                <td colSpan="8">
                                  {viewCheckData.reqInfo.REQUITIME} ,{" "}
                                  {moment(
                                    new Date(viewCheckData.reqInfo.REQUIDATE)
                                  ).format(" DD-MM-YYYY")}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Requisition ID</td>
                                <td colSpan="8">
                                  {viewCheckData.reqInfo.REQUISITIONNO}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Employee Name</td>
                                <td colSpan="8">
                                  {viewCheckData.reqInfo.NAME_ENGLISH}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Designation</td>
                                <td colSpan="8">
                                  {viewCheckData.reqInfo.DESIGNATION}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="4">Department</td>
                                <td colSpan="8">
                                  {viewCheckData.reqInfo.DEPARTEMENT}
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor">
                              <th colSpan="2">S/N </th>
                              <th colSpan="4">Products</th>
                              <th colSpan="2">Request</th>
                              <th colSpan="2">Last Date</th>
                              <th colSpan="2">Last Qty</th>
                              <th colSpan="2">
                                Total Qty ({new Date().getFullYear()})
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewCheckData.productsInfo &&
                              viewCheckData.productsInfo.map(
                                (product, index) => (
                                  <tr key={index}>
                                    <th className="text-center" colSpan="2">
                                      {++index}
                                    </th>
                                    <td colSpan="4">
                                      {product.PRONAME}
                                      <br />
                                      {product.PRONAMETWO}
                                    </td>
                                    <td colSpan="2" className="text-center">
                                      {product.PROREQUQTY}
                                    </td>
                                    <td colSpan="2">
                                      {product.LAST_DATE
                                        ? moment(
                                          new Date(product.LAST_DATE)
                                        ).format("DD-MM-YYYY")
                                        : ""}
                                    </td>
                                    <td className="text-center" colSpan="2">
                                      {product.LAST_QTY}{" "}
                                    </td>
                                    <td className="text-center" colSpan="2">
                                      {product.TOTAL_QTY > 0
                                        ? product.TOTAL_QTY
                                        : 0}
                                    </td>
                                  </tr>
                                )
                              )}
                            <tr className="lh-lg">
                              <th colSpan="2"></th>
                              <td colSpan="4" className="fw-bold text-center">
                                Total Required Quantities{" "}
                              </td>
                              <td colSpan="2" className="fw-bold text-center">
                                {viewCheckData.totalQty}{" "}
                              </td>
                              <td colSpan="6"> </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-5 col-lg-5">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="tableColor text-white  mb-1">
                              <th colSpan="12">Current Stock Status</th>
                            </tr>
                            <tr className=" tableColor  lh-lg">
                              <th colSpan="4">S/N </th>
                              <th colSpan="4">Product</th>
                              <th colSpan="4">Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewCheckData.stockInfo &&
                              viewCheckData.stockInfo.map((product, index) => (
                                <tr className="lh-lg" key={index}>
                                  <th className="text-center" colSpan="4">
                                    {++index}
                                  </th>
                                  <td colSpan="4">{product.proname}</td>
                                  <td colSpan="4" className="text-center">
                                    {product.proqty}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor mb-1">
                              <th colSpan="12">Approved By Admin</th>
                            </tr>
                            <tr

                              className=" tableColor "
                            >
                              <th colSpan="4">S/N </th>
                              <th colSpan="4">Approved Product</th>
                              <th colSpan="4">Approved Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewCheckData.adminApproved &&
                              viewCheckData.adminApproved.map(
                                (product, index) => (
                                  <tr className="lh-lg" key={index}>
                                    <th colSpan="4">{++index}</th>
                                    <td colSpan="4">{product.proname}</td>
                                    <td colSpan="4" className="text-center">
                                      {product.aproqty}
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-12">
                    <div className="mt-3">
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor ">
                              <th colSpan="1">S/N </th>
                              <th colSpan="2">Products</th>
                              <th colSpan="1">Units</th>
                              <th colSpan="2">User Remarks</th>
                              <th colSpan="2">Admin Remarks</th>
                              <th colSpan="2">Approved</th>
                              <th colSpan="2">Store Remarks</th>
                            </tr>
                          </thead>
                          {/* productArray */}
                          <tbody>
                            {viewCheckData &&
                              viewCheckData.productsInfo.map(
                                (product, index) => (
                                  <tr key={index}>
                                    <td colSpan="1" className="text-center">
                                      {++index}
                                    </td>
                                    <td colSpan="2">
                                      {product.PRONAME} <br />
                                      {product.PRONAMETWO}
                                    </td>
                                    <td colSpan="1">{product.UNIT}</td>
                                    <td colSpan="2">
                                      <textarea
                                        type="text"
                                        style={{
                                          width: "100%",
                                          height: "70px",
                                          paddingLeft: "5px",
                                        }}
                                        className="input-field-new"
                                        placeholder={product.USER_REMARKS}
                                        disabled
                                      />
                                    </td>
                                    <td colSpan="2">
                                      <textarea
                                        type="text"
                                        style={{
                                          width: "100%",
                                          height: "70px",
                                          paddingLeft: "5px",
                                        }}
                                        className="input-field-new"
                                        placeholder={product.ADMIN_REMARKS}
                                        disabled
                                      />
                                    </td>
                                    <td colSpan="2">
                                      {" "}
                                      <input
                                        type="number"
                                        style={{
                                          width: "100%",
                                          paddingLeft: "5px",
                                          height: "40px",
                                        }}
                                        onChange={(e) => {
                                          updateProduct(
                                            product.PROID,
                                            parseInt(e.target.value),
                                            "APROQTY"
                                          );
                                          // console.log(productArray)
                                        }}
                                        className="input-field-new text-center"
                                        defaultValue={product.APROQTY}
                                      />
                                    </td>
                                    <td colSpan="2">
                                      <textarea
                                        type="text"
                                        style={{
                                          width: "100%",
                                          height: "70px",
                                          paddingLeft: "5px",
                                        }}
                                        onChange={(e) => {
                                          updateProduct(
                                            product.PROID,
                                            e.target.value,
                                            "STOREREMARK"
                                          );
                                        }}
                                        className="input-field-new"
                                      />
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {logInStatus === 24 ? (
                <>
                  {/* <div className="d-flex justify-content-center mt-5">
                    <div className="mb-3 w-50">
                      <label
                        for="exampleFormControlInput1"
                        className="form-label"
                      >
                        Product Given Status{" "}
                        <span className="color-red">*</span>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onClick={(e) => {
                          setGivenStatus(e.target.value);
                        }}
                      >
                        <option value="" className="fs-5">
                          Select...
                        </option>
                        <option value={1} className="fs-5">
                          Given
                        </option>
                        <option value={0} className="fs-5">
                          Not given
                        </option>
                      </select>
                    </div>
                  </div> */}

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "30px",
                      marginBottom: "30px",
                    }}
                  >
                    <button
                      onClick={handleRequest}
                      className="btn btn-wide btn-o btn-color_store"
                      style={{ borderRadius: "10px" }}
                    >
                      <i className="fa fa-check-circle-o"></i> Check Out
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewCheckout;
